var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrgaLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 78.75 71.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#10a84b;}.cls-3{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 242.1,
    y1: -159.37,
    x2: 41.14,
    y2: 41.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#10a84b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60,35.77A24.15,24.15,0,1,1,55,21.1l9.35-7a35.72,35.72,0,1,0,7.4,21.72A35.37,35.37,0,0,0,69,22L58.19,26.57A23.9,23.9,0,0,1,60,35.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.56,27.46c-.14-.19-.27-.37-.43-.55a13.52,13.52,0,1,0,2.33,3.81L34.09,36.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.66,9.57q-4.59,2.91-9.11,5.83l-.83.54q-4.95,3.2-9.8,6.41-4.43,2.92-8.79,5.88-5.81,3.91-11.49,7.86c3.56-2,7.75-4.24,12.28-6.53,3-1.53,6.23-3.09,9.49-4.66,3.49-1.68,7.06-3.37,10.61-5l1-.46c3.3-1.53,6.58-3,9.74-4.45A47.25,47.25,0,0,0,75.66,9.57Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgaLogo);
export default __webpack_public_path__ + "static/media/orgaLogo.d0eee57220ec40cde9636e15953efd58.svg";
export { ForwardRef as ReactComponent };